import React from 'react'
import AccountByUserProvider from './index.provider'
import AccountByUserTabContent from './index.content'

const AccountByUserTab: React.FC<{ onUpload: () => any; resetView: boolean }> = (props) => {
  return (
    <AccountByUserProvider>
      <AccountByUserTabContent {...props} />
    </AccountByUserProvider>
  )
}

export default AccountByUserTab
